import React, { useState, useEffect } from "react";
import useTranslation from "../../components/CustomHooks/useTranslation";
import { contents } from "../../pages/auth/AuthContents";
interface ResendOtpProps {
  onResend: (type: string) => void; // Accepts a string argument
  maxResendAttempts: number;
}

const ResendOtpButton: React.FC<ResendOtpProps> = ({ onResend, maxResendAttempts }) => {
  const [timeLeft, setTimeLeft] = useState<number>(120); // Countdown timer in seconds
  const [resendAttempts, setResendAttempts] = useState<number>(0);
  const { translate, replace } = useTranslation(contents["login"]);
  
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [timeLeft]);

  const handleResend = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (resendAttempts < maxResendAttempts) {
      onResend('otp');
      setTimeLeft(120); // Reset the timer after sending OTP
      setResendAttempts((prev) => prev + 1); // Increment resend attempts
    }
  };

  return (
    <div className="mt-4">
      <p className="text-gray-600">
        {resendAttempts >= maxResendAttempts ? '' : translate('Didn’t receive OTP?')}
        <button
          type="button"
          className={`ml-2 text-p_primary ${(resendAttempts >= maxResendAttempts || timeLeft > 0) ? '' : 'cursor-pointer'}` }
          onClick={handleResend}
          disabled={resendAttempts >= maxResendAttempts || timeLeft > 0}
        >
          {resendAttempts >= maxResendAttempts ? 
          translate('Resend limit exceeded')
          :timeLeft > 0 ? (
            replace(translate('Resend in {{minutes}}:{{seconds}}'), {
              minutes: Math.floor(timeLeft / 60).toString(),
              seconds: (timeLeft % 60 < 10 ? "0" : "") + (timeLeft % 60).toString()
            })
          ) : (
            translate('Resend')
          )}
        </button>
      </p>
    </div>
  );
};

export default ResendOtpButton;
